
/* eslint-disable no-param-reassign */
export const setVersion = (state, version) => {
  state.version = version; //eslint-disable-line
};
export const setConfig = (state, data) => {
  state.config = data; //eslint-disable-line
};
export const setInit = (state, bool) => {
  state.init = bool; //eslint-disable-line
};
export const setLoaded = (state, bool) => {
  state.loaded = bool; //eslint-disable-line
};
export const setTokenPrices = (state, products) => {
  products.forEach((product) => {
    product.price = window.products[product.globalId].priceElement?.innerText || '';
    if (window.products[product.globalId].priceElement?.innerText === undefined) console.error('Price token not found for product', product.globalId);
  });
};
export const setMobile = (state, bool) => {
  state.isMobile = bool; //eslint-disable-line
};
export const setBrowser = (state, val) => {
  state.browser = val; //eslint-disable-line
};

export const setCurrentWave = (state, wave) => {
  if (state.attributes.wave !== undefined) {
    state.attributes.wave = wave;
  }
  state.wave = wave;
};

export const setTheme = (state, collection) => {
  console.log('Setting theme to collection:', collection);
  if (collection && collection.available && collection.theme) {
    state.theme = collection.theme;
  } else {
    console.log('Reverting to default theme');
    state.theme = state.defaultTheme || state.defaultCollection;
  }
};
